import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastCall, TreCxService, TypeSource, WSResponse3cx, WsStatus } from '../../services/3cx.service';
import { Apiservice } from '../../services/api.service';
import { Contatto, ListaSedi } from '../CRM/crm-contatti/interfaces';
import { FormsTemplateService } from '../../services/forms-template.service';

export type SearchTelefonoRes = {
  code: number
  message: string
  data: Array<SearchTelefonoData>
  value: number
  query: number
  filter: string
  QueryOdata: string
  QueryPerCount: string
}
export type SearchTelefonoData = {
  id: number
  Soggetto: number
  Sede: number
  nome: string
  telefono: string
}
export type DataCall = {
  contatto: Contatto | null,
  sede: string[],
  type: TypeSource,
  number: string,
  nomeCognome: string,
}


@Component({
  selector: 'app-nica-3cx-call',
  templateUrl: './nica-3cx-call.component.html',
  styleUrls: ['./nica-3cx-call.component.css']
})
export class NicaTreCxCallComponent implements OnInit, OnDestroy {
  protected status: WsStatus | undefined
  protected toastCall: ToastCall | null = null
  protected dataCall: DataCall[] = []
  protected statiCliente: Map<number, any> = new Map()
  private $destroy: Subject<void> = new Subject()

  constructor(private treCxService: TreCxService, private readonly api: Apiservice, private readonly formTemplate: FormsTemplateService) { }
  ngOnDestroy(): void {
    this.$destroy.next()
    this.$destroy.complete()
  }

  ngOnInit() {
    this.treCxService.onStatus().pipe(takeUntil(this.$destroy)).subscribe((val) => { this.status = val })
    this.formTemplate.getDati('stCliente').forEach(element => {
      this.statiCliente.set(element.key, element)
    });
    console.log(this.statiCliente.values())
    this.treCxService.toasts$.pipe(takeUntil(this.$destroy)).subscribe(async list => {
      if ((this.toastCall && this.toastCall.status) === (list && list.status)) return;
      console.log(list)
      this.toastCall = list;
      if (list === null) return;
      this.dataCall = await this.processCaller(list.data)
      if (list.status === 'Disconnected') setTimeout(() => this.removeToast(), 20000);
    });
  }
  removeToast() {
    this.treCxService.removeToast()
  }
  onReconnect(): void {
    this.treCxService.reconnect();
  }
  get label(): string {
    switch (this.status) {
      case 'CONNECTED': return '3cx Connesso';
      case 'CONNECTING': return '3cx Connessione...';
      default: return '3cx Disconnesso';
    }
  }

  get dotClass(): string {
    switch (this.status) {
      case 'CONNECTED': return 'dot dot-green';
      case 'CONNECTING': return 'dot dot-blue';
      default: return 'dot dot-red';
    }
  }

  get canReconnect(): boolean {
    return this.status !== 'CONNECTING';
  }
  private async processCaller(data: WSResponse3cx): Promise<DataCall[]> {
    const participant = data.participants[0]
    const rawNumber = participant.party_caller_id.trim();
    const hasInternationalPrefix = /^\+\d{1,3}/.test(rawNumber);
    const number = hasInternationalPrefix ? rawNumber : rawNumber.length > 3 ? `+39${rawNumber}` : rawNumber;
    if (!number) return [];
    const dataCall: DataCall[] = []

    switch (participant.party_dn_type) {
      case 'Wexternalline':
        dataCall.push(...await this.processTel(number))
        break;
      case 'Wextension':
      case 'Wroutepoint':
        dataCall.push({ contatto: null, nomeCognome: participant.party_caller_name, number: participant.party_caller_id, sede: null, type: participant.party_dn_type })
        break;
      default:
        break;
    }

    console.log(dataCall)
    return dataCall
  }

  private async processTel(number: string): Promise<DataCall[]> {
    const dataCall: DataCall[] = []
    const telefono: SearchTelefonoRes = await this.api.GetApiRest(`trovaSoggettoPerNumeroTelefono?telefono=${number}`) as SearchTelefonoRes
    if (telefono.data.length > 0) {
      const listSoggetti = new Map<number, SearchTelefonoData[]>()
      telefono.data.forEach(element => {
        if (!listSoggetti.has(element.Soggetto)) listSoggetti.set(element.Soggetto, [element])
        else listSoggetti.set(element.Soggetto, [element, ...listSoggetti.get(element.Soggetto)])
      });
      for (let key of listSoggetti.keys()) {
        const res = await this.api.GetApiRest(`contatti/${key}`) as Record<string, any>
        const soggetto = listSoggetti.get(key)
        soggetto.forEach((val) => {
          const contatto = res.data as Contatto

          const sedeLabel =
            val.Sede !== 0
              ? contatto.listaSedi.find(s => s.Cod === val.Sede).Ind || "Sede sconosciuta"
              : "Sede Legale"

          dataCall.push({
            contatto,
            number: val.telefono,
            sede: [sedeLabel],
            type: 'Wexternalline',
            nomeCognome: val.nome
          })

        })
      }
    }
    const unique = new Map<number, DataCall>()

    for (const item of dataCall) {
      const key = item.contatto.Cod

      if (!unique.has(key)) {
        unique.set(key, {
          ...item,
          sede: [...item.sede]
        })
      } else {
        const existing = unique.get(key)!
        existing.sede.push(...item.sede)
        existing.sede = [...new Set(existing.sede)]
      }
    }

    return [...unique.values()]

  }
}
